import React from 'react'
import { twMerge } from 'tailwind-merge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner'

import * as defaultVariants from './variants'

export const Button = ({
    variantColor = 'primary',
    variantStyle = 'solid',
    variants = defaultVariants,
    loading = false,
    className = '',
    children,
    href,
    ...restProps
}) => {
    let variantClassName = ''

    if (variants?.[variantColor]) {
        switch (variantStyle) {
            case 'outline':
                variantClassName = variants[variantColor]?.outlineClasses || ''
                break
            case 'link':
                variantClassName = variants[variantColor]?.linkClasses || ''
                break
            default:
                variantClassName = variants[variantColor]?.solidClasses || ''
        }
    }

    return href ? (
        <a
            type="button"
            href={href}
            className={`${twMerge(`${variantClassName} ${className}`)}`}
            {...restProps}
        >
            {children}
        </a>
    ) : (
        <button className={`${twMerge(`${variantClassName} ${className}`)}`} {...restProps}>
            {loading ? <FontAwesomeIcon icon={faSpinner} className="fa-spin" /> : children}
        </button>
    )
}

export default Button
